import { render, staticRenderFns } from "./setting-board.vue?vue&type=template&id=e225db26"
import script from "./setting-board.vue?vue&type=script&lang=js"
export * from "./setting-board.vue?vue&type=script&lang=js"
import style0 from "./setting-board.vue?vue&type=style&index=0&id=e225db26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports